module.exports = __webpack_public_path__ + "static/media/attentiondark.2223aa20.svg";